// The few words Console D's components say themselves (APS-412): a status's word and the code
// window's Copy. Each app supplies them in its language (the console from its catalogue), so
// the components hold no copy of their own.
import { createContext, type ReactNode, useContext } from 'react'
import type { StatusKey } from './d/Status'

export interface UiText {
  status: Record<StatusKey, string>
  copy: string
  copied: string
  copyFailed: string
}

const UiTextContext = createContext<UiText | null>(null)

export function UiTextProvider({ value, children }: { value: UiText; children: ReactNode }) {
  return <UiTextContext.Provider value={value}>{children}</UiTextContext.Provider>
}

/** The app's words; a component outside a UiTextProvider is a wiring bug, so it says so. */
export function useUiText(): UiText {
  const text = useContext(UiTextContext)
  if (!text)
    throw new Error('@apsio/ui: a component needs its words; wrap the app in UiTextProvider')
  return text
}
